import { render, staticRenderFns } from "./VoucherCameraScanner.vue?vue&type=template&id=04533294&scoped=true"
import script from "./VoucherCameraScanner.vue?vue&type=script&lang=js"
export * from "./VoucherCameraScanner.vue?vue&type=script&lang=js"
import style0 from "./VoucherCameraScanner.vue?vue&type=style&index=0&id=04533294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04533294",
  null
  
)

export default component.exports